import React, { useCallback, useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LoadingScreen from './components/LoadingScreen';
import ScrollToTop from './components/shared/ScrollToTop';
import AdmissionEnquiryTab from './components/shared/AdmissionEnquiryTab';

import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import AcademicsPage from './pages/AcademicsPage';
import AdmissionsPage from './pages/AdmissionsPage';
import CommunityPage from './pages/CommunityPage';
import ScottianLifePage from './pages/ScottianLifePage';
import ProspectusPage from './pages/ProspectusPage';
import SportsCoCurricularPage from './pages/SportsCoCurricularPage';
import ParentLoginPage from './pages/ParentLoginPage';
import PrincipalDeskPage from './pages/PrincipalDeskPage';

// --- CMS admin shell ---
import { AuthProvider } from './cms/auth/AuthContext';
import RequireAuth from './cms/admin/RequireAuth';
import LoginPage from './cms/admin/LoginPage';
import AdminLayout from './cms/admin/AdminLayout';
import AdminPage from './cms/admin/AdminPage';
import SeedLoader from './cms/admin/SeedLoader';

function PublicShell({ children }) {
  const [showLoading, setShowLoading] = useState(true);
  const handleLoadingFinish = useCallback(() => setShowLoading(false), []);

  useEffect(() => {
    document.body.classList.toggle('is-loading', showLoading);
    return () => document.body.classList.remove('is-loading');
  }, [showLoading]);

  return (
    <>
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 z-[40] mix-blend-overlay opacity-[0.06] bg-noise bg-[length:200px_200px]"
      />
      <AdmissionEnquiryTab />
      <div className="min-h-screen flex flex-col">
        {showLoading && <LoadingScreen onFinish={handleLoadingFinish} />}
        <Navbar />
        <main className="flex-1" aria-hidden={showLoading}>
          {children}
        </main>
        <Footer />
      </div>
    </>
  );
}

function AppRoutes() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/website_admin');

  if (isAdminRoute) {
    return (
      <AuthProvider>
        <Routes>
          <Route path="/website_admin/login" element={<LoginPage />} />
          <Route
            path="/website_admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="home" replace />} />
            <Route path="_seed" element={<SeedLoader />} />
            <Route path=":slug" element={<AdminPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    );
  }

  return (
    <PublicShell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/academics" element={<AcademicsPage />} />
        <Route path="/admissions" element={<AdmissionsPage />} />
        <Route path="/community" element={<CommunityPage />} />
        <Route path="/scottian-life" element={<ScottianLifePage />} />
        <Route path="/prospectus" element={<ProspectusPage />} />
        <Route path="/sports-co-curricular" element={<SportsCoCurricularPage />} />
        <Route path="/parent-login" element={<ParentLoginPage />} />
        <Route path="/principal-desk" element={<PrincipalDeskPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </PublicShell>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
